import React, { useState } from "react";
import InsightsSideBar from "../../../InsightsSideBar";
import { useReports } from "./hooks/useReports";
import { useDownloadExcel } from "./hooks/useDownloadExcel";
import { ReportLayout } from "../../../components/ReportLayout/ReportLayout";
import { Header } from "./components/Header";
import { Table } from "./components/Table";
import { ModalFilter } from "./components/ModalFilter";
import { usePrefill } from "./hooks/usePrefill";
import { useShareToLeadAr } from "./hooks/useShareToLeadAr";

export function RetentionRateDetailsReport() {
  const [isFilterOpen, setIsFilterOpen] = useState(false);
  const { reports, filter, order, period, rebooked } = useReports();

  const downloadExcel = useDownloadExcel({
    period,
    filter: filter.preparedForRequest,
    order,
    rebooked: rebooked.value,
  });

  const shareToLeadAr = useShareToLeadAr({
    period: period.value,
    filter: filter.value,
    order: order.value,
  });

  usePrefill({ filter, period });

  return (
    <div id="content">
      <div className="container-fluid content setting-wrapper">
        <InsightsSideBar />
        <div className="memberWalletOuter business-section">
          <ReportLayout>
            <Header
              period={period}
              onFilterOpen={() => setIsFilterOpen(true)}
              downloadExcel={downloadExcel}
              isReportsLoading={reports.isLoading}
              isFilterActive={filter.isActive}
              rebooked={rebooked}
              shareToLeadAr={shareToLeadAr}
            />
            <Table reports={reports} order={order} rebooked={rebooked.value} />
            <ModalFilter
              isOpen={isFilterOpen}
              onClose={() => setIsFilterOpen(false)}
              filter={filter}
            />
          </ReportLayout>
        </div>
      </div>
    </div>
  );
}
